import classes from "./AppLogo.module.scss";

const AppLogo = function () {
  return (
    <div className={classes.logo}>
      <p>WEATHER.NOW</p>
    </div>
  );
};

export default AppLogo;
